"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _colorManipulator = require("@material-ui/core/styles/colorManipulator");

var _variables = _interopRequireDefault(require("../utils/variables"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var styles = function styles(theme) {
  var _restricted;

  var themeColor = _variables["default"].primaryTheme || theme.palette.primary.main;
  return {
    button: {
      color: _variables["default"].white,
      fontSize: 14,
      lineHeight: "16px",
      padding: "8px 16px",
      borderRadius: 34,
      transition: "all .4s ease-in-out",
      fontFamily: "latoregular",
      display: "inline-block",
      margin: theme.spacing.unit,
      border: "none",
      textTransform: "none"
    },
    restricted: (_restricted = {
      color: _variables["default"].white,
      display: "flex",
      fontSize: 14,
      padding: "9px 17px",
      transition: "all .4s ease-in-out"
    }, _defineProperty(_restricted, "display", "inline-block"), _defineProperty(_restricted, "border", "none"), _defineProperty(_restricted, "textTransform", "none"), _defineProperty(_restricted, "background", "#17a180"), _defineProperty(_restricted, "&:hover", {
      background: "#17a180",
      cursor: "default"
    }), _restricted),
    text: {
      color: themeColor,
      borderRadius: 2
    },
    "default": {
      background: themeColor,
      "&:hover": {
        background: (0, _colorManipulator.darken)(themeColor, 0.12)
      }
    },
    primary: {
      background: _variables["default"].orange,
      "&:hover": {
        background: (0, _colorManipulator.darken)(_variables["default"].orange, 0.12)
      }
    },
    outlined: {
      boxShadow: "none",
      background: _variables["default"].white,
      color: themeColor,
      border: "1px solid ".concat(themeColor),
      "&:hover": {
        background: themeColor,
        color: _variables["default"].white
      }
    },
    underlined: {
      fontSize: "13px",
      padding: "0px",
      borderRadius: "0px",
      boxShadow: "none",
      background: "transparent",
      color: "#292929",
      borderBottom: "1px solid #f8bf45",
      minWidth: "fit-content"
    },
    secondary: {
      fontSize: "14px",
      padding: "8px 16px",
      borderRadius: "4px",
      boxShadow: "none",
      background: "#ffffff",
      color: "#3B3F46",
      border: "1px solid #E0E0E0",
      minWidth: "fit-content",
      "&:hover": {
        background: (0, _colorManipulator.darken)(_variables["default"].white)
      }
    },
    isLoading: {
      color: "transparent",
      pointerEvents: "none"
    },
    disabled: {
      opacity: 0.4,
      pointerEvents: "none"
    },
    loader: {
      position: "absolute",
      top: "33%",
      left: "42%",
      color: _variables["default"].white
    },
    info: {
      boxShadow: "none",
      background: _variables["default"].white,
      color: themeColor,
      fontWeight: "600",
      fontSize: ".85rem"
    },
    labelSuccess: {
      backgroundColor: "#e8f7f3",
      color: "#17a180",
      cursor: "text!important",
      "&:hover": {
        background: "rgba(10, 187, 135, .1)"
      }
    },
    labelDanger: {
      backgroundColor: "#f8ede2",
      color: "#e92f00",
      cursor: "text!important",
      "&:hover": {
        background: "rgba(253, 57, 122, .1)"
      }
    },
    labelWarning: {
      backgroundColor: "#fff9e5",
      color: "#f39745",
      cursor: "text!important",
      "&:hover": {
        background: "rgba(255, 184, 34, .1)"
      }
    },
    labelInfo: {
      backgroundColor: "rgba(93, 120, 255, .1)",
      color: "#5d78ff",
      cursor: "text!important",
      "&:hover": {
        background: "rgba(93, 120, 255, .1)"
      }
    },
    labelDebug: {
      backgroundColor: "#F2F2F2",
      color: "#7D7D7D",
      cursor: "text!important",
      "&:hover": {
        background: "#F2F2F2"
      }
    },
    labelDisabled: {
      pointerEvents: "none"
    },
    startIcon: {
      marginRight: '8px'
    }
  };
};

var _default = styles;
exports["default"] = _default;